import React from 'react'
import { Flex, LogoutIcon, UserMenu as UIKitUserMenu, UserMenuItem } from '@pancakeswap/uikit'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { useTranslation } from 'contexts/Localization'
import { useXrpl } from '../../../xrpl'

const UserMenu = () => {
  const { t } = useTranslation()
  const { account, disconnect } = useXrpl()

  if (!account) {
    return <ConnectWalletButton scale="sm" />
  }

  return (
    <UIKitUserMenu account={account}>
      <UserMenuItem as="button" onClick={disconnect}>
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          {t('Disconnect')}
          <LogoutIcon />
        </Flex>
      </UserMenuItem>
    </UIKitUserMenu>
  )
}

export default UserMenu
